import { p as parseCookies } from "../../../cookies-04bd2321.js";
import { getSessionId } from "./getSession.es.js";
import { deepEquals } from "../../../utils/deepEquals.es.js";
import { formatMerkleData } from "./utils.es.js";
import { updateIdcsSession } from "../../services/idcs-service.es.js";
import { merkleDataTracker, setMerkleDataTracker } from "../../../utils/merkleDataTracker.es.js";
import { userInsights, setUserInsights } from "../../../utils/userInsights.es.js";
import { g as getTealiumIds } from "../../../getTealiumIds-c24d3498.js";
import { getMerkleIds } from "../merkle/getMerkleIds.es.js";
import { getVisitId } from "../visitId/visitId.es.js";
import "../../../utils/logger.es.js";
import "../utils/getUtmParams.es.js";
import "../../../utils/sharedServiceUrl.es.js";
import "../../../waitFor-1b67bbb8.js";
import "../../../cookieHandler-ac6954c1.js";
import "../visitId/adapter.es.js";
import "../../../processUrlVisitId-15beb53d.js";
import "../../../v4-88c20f3b.js";
import "../visitId/utils.es.js";
import "../visitId/constants.es.js";
const getUserInsightsData = async (sessionId, merkleData, isFirstTime = false) => {
  const cookies = parseCookies();
  const previousVisitId = cookies["eh_previous_visit_id"];
  const visitId = getVisitId();
  const { tealium_visitor_id } = await getTealiumIds();
  const formBody = {
    id: sessionId,
    visitId,
    previousVisitId,
    tealiumVisitorID: tealium_visitor_id,
    ...merkleData ? formatMerkleData(merkleData) : {}
  };
  const userInsightData = await updateIdcsSession(sessionId, { ...formBody });
  setUserInsights({ fired: isFirstTime ? true : userInsights.fired, insights: userInsightData });
};
const getUserInsights = async () => {
  const merkleData = await getMerkleIds();
  const isMerkleDataSame = deepEquals(merkleDataTracker, merkleData);
  const sessionId = await getSessionId();
  if (!userInsights.fired && sessionId) {
    await getUserInsightsData(sessionId, merkleData || void 0, true);
    return userInsights.insights;
  }
  if (sessionId && merkleData && !isMerkleDataSame) {
    await getUserInsightsData(sessionId, merkleData);
    setMerkleDataTracker(merkleData);
    return userInsights.insights;
  }
  return userInsights.insights;
};
export {
  getUserInsights
};
